import { render, staticRenderFns } from "./FCV01.vue?vue&type=template&id=5287325e&scoped=true"
import script from "./FCV01.vue?vue&type=script&lang=js"
export * from "./FCV01.vue?vue&type=script&lang=js"
import style0 from "./FCV01.vue?vue&type=style&index=0&id=5287325e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5287325e",
  null
  
)

export default component.exports